import apiClient from "./apiClient";

// Employees submit one DTR per week (Mon–Sun). Weeks crossing a payroll
// cut-off (9th/10th, 24th/25th) are split and submitted separately.
//
// Period  { key, year, month, cutoff: 0|1|2, start, end, processOn, label }
//   cutoff 1: 25th of the previous month → 9th; cutoff 2: 10th → 24th; 0: old monthly DTRs
// Week    { start, end, weekStart, partial, label, cutoff: Period }
//
// The employee is taken from the access token.
// There is no weekly submit: HR approves each employee's cut-off, then exports it.
// Period status for the employee: OPEN | APPROVED | EXPORTED (exported = locked).
//
// Day { date, weekday, status: PRESENT|LATE|HALF_DAY|ABSENT|ON_LEAVE|HOLIDAY|REST_DAY|NO_RECORD,
//       future, leaveType, holiday: { name, type }|null, attendanceId, firstCheckIn, lastCheckOut,
//       workHours, overtimeHours, unapprovedExtraMinutes, isLate, isCorrected, source, remarks,
//       sessionCount, missingCheckOut, pendingCorrection: { id, requested }|null, pendingOvertime }
export const dtrService = {
  // { current, lastFinished, currentWeek, lastWeek, periods: Period[] } (periods of `year`)
  getPeriods: ({ year } = {}) =>
    apiClient.get("/dtr/periods", { params: year ? { year } : {} }),

  // { current, periods: [{ key, year, month, cutoff, start, end, label, processOn, isCurrent, status }] }
  // newest first (up to 24 back, not before the hire date)
  getMyPeriods: () => apiClient.get("/dtr/my/periods"),

  // { period, isCurrent, status, approvedBy, approvedByName, approvedAt, exportedAt, changedAfterApproval,
  //   processOn, locked, totals, days: Day[] } (no params = the current cut-off)
  getMyPeriod: ({ year, month, cutoff } = {}) =>
    apiClient.get("/dtr/my/period", {
      params: year ? { year, month, cutoff } : {},
    }),
};
